module.exports = __webpack_public_path__ + "img/title-03.13833d11.png";